.md {
  ul {
    list-style: disc;
  }

  img {
    max-width: 100%;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  code {
    white-space: normal;
  }
}

.more {
  font-weight: bold;
  font-size: inherit;
}
